import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const ENGAGEMENTS_ENDPOINTS = {
  V2: createEndpoints('v2', {
    ADMIN_QUESTIONS: '/engagements/admin/questions/',
    ADMIN_QUESTIONS_DASHBOARD_SUMMARY: '/engagements/admin/questions/dashboard-summary/',
    ADMIN_QUESTIONS_INSIGHTS_DASHBOARD: '/engagements/admin/questions/dashboard/',
    ADMIN_QUESTIONS_INSIGHTS_DASHBOARD_STATS: '/engagements/admin/questions/dashboard/stats/',
    ADMIN_QUESTION_DETAIL: (id: number) => `/engagements/admin/questions/${id}/`,
    ADMIN_QUESTION_ANSWERS: (id: number) => `/engagements/admin/questions/${id}/answers/`,
    ADMIN_QUESTION_LOGS: (id: number) => `/engagements/admin/questions/${id}/logs/`,
    ADMIN_ANSWER_DETAIL: (id: number) => `/engagements/admin/answers/${id}/`,
  }),
} as const;
